import React from "react"
import PSESection from "../preview/section/PSESection"
import { PSE_BLOCK_TYPES } from "../../../utils/productionStepExecution"
import ProductionStepExecutionMachinesForm from "./ProductionStepExecutionMachinesForm"

const ProductionStepExecutionCookingFormContainer = ({
	productionStepExecution,
	visible = true,
	machinesOptions,
	handleSubmit,
	updateErrorMessage,
	setNextButtonStatus
}) => {

	if (!visible) {
		return null
	}

	return (
		<PSESection
			productionStepExecution={productionStepExecution}
			sectionType={PSE_BLOCK_TYPES.COOKING}
			title="Cuisson"
			subtitle={"Saisissez l'heure et la température de fin de cuisson."}
		>
			<ProductionStepExecutionMachinesForm
				machinesBatch={productionStepExecution.machinesBatch}
				machinesOptions={machinesOptions}
				onSubmit={handleSubmit}
				onError={updateErrorMessage}
				setNextButtonStatus={setNextButtonStatus}
			/>
		</PSESection>)
}

export default ProductionStepExecutionCookingFormContainer